<template>
  <authorization permissionKey="surgery_ward_postoperative_queue" can="read">
    <attendances queueType="surgery_postoperative" medicalRecordPath="cirurgia" />
  </authorization>
</template>

<script>
import attendances from "@/components/queues/attendances.vue";

  export default {
    name: "SurgicalWardPostoperative",
    components: {
      attendances,
    },
  };
</script>

<style lang="scss" scoped></style>
